export const isProductionMode = process.env.NODE_ENV === "production";

export const getSharedListUrl = (sharedListId) => {
    return `https://www.themoviepal.app/sharedlists/${sharedListId}`;
};
